import { AuthenticatedTemplate } from '@azure/msal-react';
import { useEffect, useRef } from 'react';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import './Calendar.css';

import useClinicCalendar from './hooks/useClinicCalendar';

import useSpecialtyClinics from './hooks/useSpecialtyClinics';

import { ClinicsEnum } from './common/enums';
import CalendarComponent from './components/CalendarComponent';
import EnableEpicOutlookIntegrationAlert from './components/EnableEpicOutlookIntegrationAlert';
import RoundedContainer from './layouts/RoundedContainer';

const DIV_DEFAULT_18PX_PREVENT_LAYOUT_SHIFT = {
  height: '18px'
}

export default function Calendar(props: RouteComponentProps) {
  const firstLoad = useRef(true);

  useEffect(() => {
    firstLoad.current = false;
    document.title = "My Clinic Schedule: Calendar"
  }, []);

  const { search } = useLocation();
  const selectedClinic = new URLSearchParams(search).get("clinic") as unknown as ClinicsEnum

  function setSelectedClinic(selectedClinic: ClinicsEnum | undefined) {
    if (selectedClinic) {
      props.history.push({
        pathname: props.location.pathname,
        search: "?" + new URLSearchParams({clinic: selectedClinic}).toString()
      })
    } else {
      props.history.push({
        pathname: props.location.pathname
      })
    }
  }

  const {
    isDoingFirstLoad: isDoingFirstSpecialtyClinicLoad,
    specialtyClinicData
  } = useSpecialtyClinics(true);

  const {
    availabilityInfoForEachDay,
    isDoingFirstLoad,
    isLoading,
    isOnboarded,
    anyWarningAboutDataFeedsUsed
  } = useClinicCalendar(true, specialtyClinicData, selectedClinic);
 

  return (
    <AuthenticatedTemplate>
      <RoundedContainer title="Your Availability" subheading="Schedule a time that works. Epic, Outlook, and OMFS all in one spot">
        <div className="mb-3">
          <div>
            {!firstLoad.current && !isDoingFirstLoad && !isLoading && !isOnboarded && <EnableEpicOutlookIntegrationAlert />}
          </div>
          <div style={DIV_DEFAULT_18PX_PREVENT_LAYOUT_SHIFT}>{isLoading && !isDoingFirstLoad ? "Refreshing available time slots..." : ""}</div>
        </div>

        <CalendarComponent 
          availabilityInfoForEachDay={availabilityInfoForEachDay}
          isDoingFirstLoad={isDoingFirstLoad}
          isDoingFirstSpecialtyClinicLoad={isDoingFirstSpecialtyClinicLoad}
          selectedClinic={selectedClinic}
          setSelectedClinic={setSelectedClinic}
          anyWarningAboutDataFeedsUsed = {anyWarningAboutDataFeedsUsed}
        />
      </RoundedContainer>
    </AuthenticatedTemplate>
  );
}
